import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const ROLE_ORGANISATIONS_RESOURCE = 'roleOrganisations';

const roleOrganisationsService = ComposedComponent =>
  reduxFetch([
    {
      resource: ROLE_ORGANISATIONS_RESOURCE,
      method: 'get',
      request: (appId, installationId, featureId, roleId, communityId) => ({
        url: addParametersToUri(apiRoutes.roleOrganisations(appId, installationId, featureId, roleId), {
          communityId,
        }),
      }),
    },
  ])(ComposedComponent);

export default roleOrganisationsService;
